<template>
  <svg version="1.1" class="recycoin-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
    <path d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8c0,0,0,0,0,0c-0.3-0.8-0.6-2.1-0.6-2.1C1.5,8.6,9.3,2.3,9.3,2.3c-1.4,2.5,1.1,5.9,1.3,7.9
      c0.2,2-2.5,3.5-2.5,3.5c-1.2-3.5-0.3-7.4-0.3-7.4C6.1,11,8.4,15.7,8.5,16c4.2-0.3,7.5-3.7,7.5-8C16,3.6,12.4,0,8,0z"/>
  </svg>
</template>

<script>
  export default {
    name: 'recycoin-icon',
  };
</script>

<style lang="scss" scoped>
  .recycoin-icon {
    display: inline-block;
    vertical-align: -0.125em;

    font-size: inherit;
    height: 1em;
    overflow: visible;

    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
</style>
